// extracted by mini-css-extract-plugin
module.exports = {"root":"RoomsHeader_root__1PoJw","header":"RoomsHeader_header__2QfDc","title":"RoomsHeader_title__3TcoE"};